module.exports = __webpack_public_path__ + "img/max4.b88ea534.jpg";